import { sendSumoLog } from '../calls/sumoLogger';
import { v4 as uuidv4 } from 'uuid';

export const postDocument = async (document, token, dispatch) => {
  const doc = JSON.parse(document);
  const postURL = encodeURI(
    `${process.env.REACT_APP_COUCHBASE_URL}/lmark/`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  const body = document;
  let uniqueID = '';

  switch (doc.docType) {
    case 'ticketAction':
      uniqueID = 'ticket-action-' + uuidv4().toUpperCase();
      break;
    case 'workLog':
      uniqueID = 'work-log-' + uuidv4().toUpperCase();
      break;
    default:
      uniqueID = uuidv4().toUpperCase();
  }
  
  try {
    const data = await fetch(postURL + uniqueID, {
      method: 'PUT',
      headers,
      body,
    });

    if (!data.ok) {
      const response = JSON.parse(document);
      const errorCode = data.status;
      const errorType = 'postDocument';
      const { ticketID, responseType } = response;
      const message = `PUT request with responseType: ${responseType} for document: ${ticketID} failed errorType: ${errorCode}`;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return { error: errorCode, document: response };
    }

    return { document: doc };
  } catch (error) {
    const response = JSON.parse(document);
    const { ticketID, responseType } = response;
    const message = `PUT request with responseType: ${responseType} for document: ${ticketID} failed`;
    sendSumoLog(error, message, token, dispatch);
    return { error: error, document: response };
  }
};
